import Vue from "vue";
import Vuex from "vuex";
import "firebase/auth";
import { User } from "@/models/user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null as null | User,
    firebaseUser: null as null | firebase.User
  },
  mutations: {
    updateFirebaseUser(state, user: firebase.User) {
      state.firebaseUser = user;
    },
    updateCurrentUser(state, user: User) {
      state.currentUser = user;
    }
  },
  actions: {},
  modules: {}
});
